import React, { useContext, useEffect, useState } from "react";
import global_context from "../../../static_vars";
import FarsightApi from "../../../ApiWrapper";
import StyledDatagrid, { ColumnTypes } from "../styled_datagrid";
import dayjs from "dayjs";
import { GridCellEditStopParams, GridCellEditStopReasons, GridEnrichedColDef, MuiEvent } from "@mui/x-data-grid";
import Button from "@mui/material/Button";
import DeleteIcon from "@mui/icons-material/Delete";
import { Checkbox, Typography } from "@mui/material";
import AdaptablePageSizeGrid from "../AdaptablePageSizeGrid";

export default function OffseasonShortlist(props: { shortlist: any; from: number; until: number }) {
    const [rows, setRows] = useState([] as any[]);
    const [loading, setLoading] = useState(false);
    const context = useContext(global_context);
    const { version } = context.state;
    const effect = () => {
        if (props.shortlist) {
            setLoading(true);
            FarsightApi.get_request("Shortlist", {
                from: props.from,
                until: props.until,
                id: props.shortlist.id,
            })
                .then((data) => setRows(data))
                .then(() => setLoading(false));
        }
    };

    useEffect(effect, [props]);

    let columnGroupingModel = [
        {
            groupId: "Player",
            children: [{ field: "player" }, { field: "role" }, { field: "birthdate" }, { field: "contract_expires" }, { field: "nationality" }, { field: "lolpros_id" }, { field: "agency_id" }, { field: "last_team_id" }],
            headerClassName: "header",
        },
        {
            groupId: "SoloQ",
            children: [{ field: "soloq_games" }, { field: "avg_soloq_winrate" }, { field: "avg_soloq_performance" }, { field: "avg_soloq_relative_performance" }],
            headerClassName: "header",
        },
        {
            groupId: "Competitive",
            children: [{ field: "competitive_games" }, { field: "avg_competitive_performance" }, { field: "avg_competitive_relative_performance" }, { field: "avg_competitive_winrate" }],
            headerClassName: "header",
        },
    ];

    const grid_columns = [
        ColumnTypes.player("player", "Player"),
        ColumnTypes.role("role", "R."),
        ColumnTypes.year_date("birthdate", "Birthdate"),
        ColumnTypes.year_date("contract_expires", "Contract", { maxWidth: 50 }),
        ColumnTypes.string("nationality", "Nationality", { minWidth: 120 }),
        ColumnTypes.string("lolpros_id", "Lolpros", { hide: true }),
        ColumnTypes.string("agency_id", "Agency", { hide: true }),
        ColumnTypes.team("last_team_id", "Last Team", { minWidth: 80 }),

        ColumnTypes.short_int("soloq_games", "#"),
        ColumnTypes.percentage("avg_soloq_winrate", "WR"),
        ColumnTypes.rating("avg_soloq_performance", "P."),
        ColumnTypes.rating("avg_soloq_relative_performance", "RP"),

        ColumnTypes.short_int("competitive_games", "#"),
        ColumnTypes.percentage("avg_competitive_winrate", "WR"),
        ColumnTypes.rating("avg_competitive_performance", "P."),
        ColumnTypes.rating("avg_competitive_relative_performance", "RP"),

        {
            headerName: "Comment",
            field: "comment",
            align: "center",
            minWidth: 250,
            headerAlign: "center",
            flex: 1,
            editable: true,
            renderCell: (params: any) => (
                <Typography style={{ whiteSpace: "pre-line" }} sx={{ textAlign: "center" }}>
                    {params.value}
                </Typography>
            ),
        } as GridEnrichedColDef,

        {
            headerName: "Contacted",
            field: "contacted",
            align: "center",
            headerAlign: "center",
            minWidth: 90,
            maxWidth: 90,
            flex: 1,
            renderCell: (params) => (
                <Checkbox
                    checked={params.value}
                    onClick={() => {
                        FarsightApi.get_request("EditObject", {
                            target: "shortlistItem",
                            field: "contacted",
                            value: params.value ? 0 : 1,
                            id: params.row.id,
                        }).then(() => effect());
                    }}
                />
            ),
        } as GridEnrichedColDef,

        {
            headerName: "Locked",
            field: "locked",
            align: "center",
            headerAlign: "center",
            maxWidth: 80,
            flex: 1,
            renderCell: (params) => (
                <Checkbox
                    checked={params.value}
                    onClick={() => {
                        FarsightApi.get_request("EditObject", {
                            target: "shortlistItem",
                            field: "locked",
                            value: params.value ? 0 : 1,
                            id: params.row.id,
                        }).then(() => effect());
                    }}
                />
            ),
        } as GridEnrichedColDef,
        ColumnTypes.rating("price_per_month", "Salary", { editable: true }),
        {
            headerName: "Delete",
            field: "id",
            align: "center",
            headerAlign: "center",
            maxWidth: 80,
            flex: 1,
            renderCell: (params) => (
                <Button
                    onClick={() => {
                        FarsightApi.get_request("DeleteShortlistItem", {
                            target: "shortlist",
                            item_id: params.value,
                            shortlist_id: props.shortlist.id,
                        }).then(() => effect());
                    }}
                >
                    <DeleteIcon />
                </Button>
            ),
        } as GridEnrichedColDef,
    ];

    return (
        <AdaptablePageSizeGrid
            rowHeight={65}
            sx={{
                width: "100%",
                "& .header": {
                    width: "100%",
                    display: "flex",
                    alignItems: "flex-end",
                    justifyContent: "flex-end",
                },
                "& .border-left": {
                    borderLeft: "solid grey",
                    borderWidth: "2px",
                },
            }}
            getRowId={(row) => row.id}
            initialState={{
                sorting: {
                    sortModel: [{ field: "date", sort: "desc" }],
                },
            }}
            columns={grid_columns}
            rows={rows}
            hideFooter={false}
            columnGroupingModel={columnGroupingModel}
            experimentalFeatures={{ columnGrouping: true }}
            loading={loading}
            onCellEditStop={(params: GridCellEditStopParams, event: any) => {
                FarsightApi.get_request("EditObject", {
                    target: "shortlistItem",
                    field: params.field,
                    value: event.target.value,
                    id: params.row.id,
                }).then(() => effect());
            }}
        />
    );
}
